// Export environmental references
export const allowMockApi = false
export const hiveApiUrl = 'https://hiveapi-ca.web.app'
export const reCaptchaSiteKey = '6Lc1z84cAAAAAD6B1fU04nkX-He17oxNwnDrkc0J'
